export const featuredPortfolio = [
    {
      id: 1,
      title: "Health Hacks",
      img:
      "assests/Health.png",
    },
    {
      id: 2,
      title: "Design",
      img:
        "assests/web.png",
    },
    {
      id: 3,
      title: "Calorie Counter",
      img:
        "assests/caloriecount.PNG",
    },
    {
      id: 4,
      title: "Fitness Planner",
      img:
        "assests/fitness.PNG",
    },
    {
      id: 5,
      title: "Profile",
      img:
        "assests/profile.PNG",
    },
    {
      id: 6,
      title: "Edit Profile",
      img:
        "assests/edit.PNG",
    },
  ];
  
  export const webPortfolio = [
    {
      id: 1,
      title: "Wordle Java FX",
      img: "assests/wrdEXP.png",
    },
    {
      id: 2,
      title: "Wrong Position",
      img: "assests/wrd2.png",
    },
    {
      id: 3,
      title: "Two Wrong Positions",
      img: "assests/wrd3.png",
    },
    {
      id: 4,
      title: "Correct Word",
      img: "assests/wrd4.png",
    },
    {
      id: 5,
      title: "Illegal Guess clears",
      img: "assests/wrd5.png",
    },
    {
      id: 6,
      title: "Six Wrong Guesses",
      img: "assests/wrd6.png",
    },
  ];
  
  export const mobilePortfolio = [
    {
      id: 1,
      title: "Coming Soon",
      img: "assests/question.png",
    },
    {
      id: 2,
      title: "Coming Soon",
      img: "assests/question.png",
    },
    {
      id: 3,
      title: "Coming Soon",
      img: "assests/question.png",
    },
    {
      id: 4,
      title: "Coming Soon",
      img: "assests/question.png",
    },
    {
      id: 5,
      title: "Coming Soon",
      img: "assests/question.png",
    },
    {
      id: 6,
      title: "Coming Soon",
      img: "assests/question.png",
    },
  ];
  
  export const designPortfolio = [
    {
      id: 1,
      title: "Coming Soon",
      img: "assests/question.png",
    },
    {
      id: 2,
      title: "Coming Soon",
      img: "assests/question.png",
    },
    {
      id: 3,
      title: "Coming Soon",
      img: "assests/question.png",
    },
    {
      id: 4,
      title: "Coming Soon",
      img: "assests/question.png",
    },
    {
      id: 5,
      title: "Coming Soon",
      img: "assests/question.png",
    },
    {
      id: 6,
      title: "Coming Soon",
      img: "assests/question.png",
    },
  ];
  
  export const contentPortfolio = [
    {
      id: 1,
      title: "Coming Soon",
      img: "assests/question.png",
    },
    {
      id: 2,
      title: "Coming Soon",
      img: "assests/question.png",
    },
    {
      id: 3,
      title: "Coming Soon",
      img: "assests/question.png",
    },
    {
      id: 4,
      title: "Coming Soon",
      img: "assests/question.png",
    },
    {
      id: 5,
      title: "Coming Soon",
      img: "assests/question.png",
    },
    {
      id: 6,
      title: "Coming Soon",
      img: "assests/question.png",
    },
  ];
  